export default "__VITE_ASSET__69812043__"